import React, {useEffect} from 'react';
import useKeyPress from '../../../hooks/useKeyPress';
import {useMenu} from '../../../hooks/useMenu';
import ProgressBarView from '../../views/progressbarView';
import AbortSMV from './abort-smv';
import SMVComplete from './smv-complete';

function SmartMeterPB() {
  const leftPress = useKeyPress('ArrowLeft');
  const {onComponent} = useMenu();

  useEffect(() => {
    if (!leftPress) return;

    onComponent(<AbortSMV />);
  }, [leftPress]);

  return (
    <ProgressBarView
      title="Running SMV"
      content="Running meter verification..."
      onExit={() => onComponent(<SMVComplete />)}
      left="Abort"
    />
  );
}

export default SmartMeterPB;
